export function computeHitStopTimeScale(nowMs: number, hitStopUntilMs: number): number {
  return nowMs < hitStopUntilMs ? 0 : 1;
}
